import { mailMeUnsubscribeActions, mailMeUnsubscribeDefaultReason, mailMeUnsubscribeReasons } from "../../../../../arc/forms/unsubscribeForms.js";
import { mailMeFields } from "../MailMeForm/mailMeConfig";

export const unsubscribeReasons = mailMeUnsubscribeReasons;
export const unsubscribeDefaultReason = mailMeUnsubscribeDefaultReason;
export const getUnsubscribeCategory = category=>mailMeFields.find(field=>field.name === category) || null;

export const unsubscribeActions = mailMeUnsubscribeActions;
